import React from 'react';
import GridProductLookup from './index';
import { LookupRow } from './types';

export interface TaskTypeLookupHandlers {
  PegarValorGrid: (row: LookupRow) => void;
  Iconeadd: () => void;
  Iconeditar: (row: LookupRow) => void;
  iconeExcluir?: (row: LookupRow) => void;
}

export function renderTaskTypeLookupGrid(
  handlers: TaskTypeLookupHandlers,
): React.ReactElement {
  return (
    <GridProductLookup
      endPoint="tasktype/buscartasktype"
      listTitle="Tipos de Tarefa"
      listSubtitle="Selecione um tipo ou cadastre um novo."
      newButtonLabel="Novo tipo"
      searchPlaceholder="Pesquisar tipos de tarefa..."
      PegarValorGrid={handlers.PegarValorGrid}
      Iconeadd={handlers.Iconeadd}
      Iconeditar={handlers.Iconeditar}
      onDelete={handlers.iconeExcluir}
    />
  );
}
